import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react';

const projectId = "df8cb4fb25bd233a5125ccd99de3edcd";

const mainnet = {
  chainId: 56, // 0x13e31 in hexadecimal
  name: "BSC ",
  currency: "BNB",
  explorerUrl: "https://bscscan.com",
  rpcUrl: "https://bsc-dataseed.binance.org/",
};

const testnet = {
  chainId: 97, // 0x13e31 in hexadecimal
  name: "BSC Testnet",
  currency: "tBNB",
  explorerUrl: "https://testnet.bscscan.com/",
  rpcUrl: "https://data-seed-prebsc-1-s1.bnbchain.org:8545",
};



// 3. Create a metadata object
const metadata = {
  name: "My Website",
  description: "My Website description",
  url: "https://www.themecrypto.it", // origin must match your domain & subdomain
  icons: ["https://avatars.mywebsite.com/"],
};

// 4. Create Ethers config
const ethersConfig = defaultConfig({
  /*Required*/
  metadata,

  /*Optional*/
  enableEIP6963: true, // true by default
  enableInjected: true, // true by default
  enableCoinbase: true, // true by default
  rpcUrl: "...", // used for the Coinbase SDK
  defaultChainId: 1, // used for the Coinbase SDK
});

// 5. Create a Web3Modal instance
createWeb3Modal({
  ethersConfig,
  chains: [mainnet],
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename='/presale'>
      <App />
    </BrowserRouter>
);
